import { useEffect, useState } from 'react';
import {
  formatElapsed,
  kitchenTimerBudgetMs,
  kitchenTimerEndIso,
  kitchenTimerStart,
  kitchenTimerTone,
  shouldShowKitchenTimer,
} from '../lib/kitchenTimer';

/**
 * Cronómetro en vivo desde aceptación del pedido (mismos colores que bandeja de pedidos).
 */
function kitchenTimerEndMs(order) {
  const iso = kitchenTimerEndIso(order);
  if (!iso) return null;
  const ms = Date.parse(iso);
  return Number.isNaN(ms) ? null : ms;
}

export default function OrderKitchenTimer({ order, size = 'md', showLabel = true }) {
  const active = shouldShowKitchenTimer(order);
  const [tick, setTick] = useState(Date.now());

  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => setTick(Date.now()), 1000);
    return () => clearInterval(id);
  }, [active]);

  const startIso = kitchenTimerStart(order);
  const startMs = startIso ? Date.parse(startIso) : NaN;

  if (!active) {
    if (!startIso || Number.isNaN(startMs)) {
      return <span className="text-xs text-muted-foreground">—</span>;
    }
    const endMs = kitchenTimerEndMs(order);
    if (endMs == null) {
      return <span className="text-xs text-muted-foreground">—</span>;
    }
    const elapsed = Math.max(0, endMs - startMs);
    const textSize = size === 'lg' ? 'text-base' : 'text-xs';
    return (
      <div className="flex flex-col items-end gap-0.5">
        <span
          className={`inline-flex font-mono tabular-nums px-2 py-0.5 rounded-md border bg-muted/50 text-muted-foreground ${textSize}`}
          title="Tiempo total en cocina (detenido)"
        >
          {formatElapsed(elapsed)}
        </span>
        {showLabel ? (
          <span className="text-[10px] text-muted-foreground">cocina cerrada</span>
        ) : null}
      </div>
    );
  }

  if (!startIso || Number.isNaN(startMs)) {
    return <span className="text-xs text-muted-foreground">Sin hora de aceptación</span>;
  }

  const elapsed = tick - startMs;
  const budgetMs = kitchenTimerBudgetMs(order, startMs);
  const tone = kitchenTimerTone(elapsed, budgetMs);
  const pct = budgetMs > 0 ? Math.round((elapsed / budgetMs) * 100) : 0;
  const textSize = size === 'lg' ? 'text-xl sm:text-2xl' : 'text-sm';

  return (
    <div className="flex flex-col items-end gap-0.5">
      <span
        className={`inline-flex items-center justify-center font-mono font-semibold tabular-nums px-2.5 py-1 rounded-md border ${textSize} ${tone}`}
        title={`Tiempo en preparación · ${pct}% del tiempo hasta la ETA`}
      >
        {formatElapsed(elapsed)}
      </span>
      {showLabel ? (
        <span className="text-[10px] text-muted-foreground">desde aceptación</span>
      ) : null}
    </div>
  );
}
